import { awsRegions } from 'customers/tenants-list-view/constants/regions';

export const getCommaSeparatedRegionNames = (cloudRegions) => {
  const regions = cloudRegions?.[0]?.regions;
  const regionNames = regions?.map((_item) => {
    return awsRegions?.find((i) => i?.value === _item?.region)?.name;
  });
  return regionNames?.join(' , ')?.toString() || '-';
};
